export const EVALUATION_TYPES = ["quiz", "video_submission", "document_submission", "acknowledgement"]

export const EVALUATION_LABELS = {
  quiz: "Wissenstest",
  video_submission: "Video-Abgabe",
  document_submission: "Praxisaufgabe als PDF",
  acknowledgement: "Bestätigung ohne Test",
}

export function getEvaluationTypes(module) {
  if (!module) return []
  if (Array.isArray(module.evaluationTypes) && module.evaluationTypes.length) {
    return EVALUATION_TYPES.filter((type) => module.evaluationTypes.includes(type))
  }
  const legacy = module.evaluationType || (module.evaluation && module.evaluation.type) || (module.quiz ? "quiz" : "acknowledgement")
  if (legacy === "video") return ["video_submission"]
  return EVALUATION_TYPES.includes(legacy) ? [legacy] : []
}

export function getCompletedEvaluationTypes(module, progress) {
  if (!progress) return []
  const completed = new Set(progress.evaluationExemptions || [])
  if (Array.isArray(progress.evaluationCompletions)) {
    progress.evaluationCompletions.forEach((entry) => {
      if (entry.completedAt) completed.add(entry.type)
    })
  } else if (progress.evaluationType && progress.evaluationCompletedAt) {
    completed.add(progress.evaluationType)
  }
  if ((progress.quizAttempts || []).some((attempt) => attempt.passed)) completed.add("quiz")
  return getEvaluationTypes(module).filter((type) => completed.has(type))
}

export function getEvaluationInstructions(module, type) {
  const instructions = module && module.evaluationInstructionsByType
  if (instructions && typeof instructions[type] === "string") return instructions[type]
  return module && module.evaluationType === type ? module.evaluationInstructions || "" : ""
}

export function getModuleProgress(module, progress) {
  if (!module || !progress) return 0
  if (progress.completedAt) return 100
  const lessonIds = new Set((module.lessons || []).map((lesson) => String(lesson && (lesson._id || lesson))))
  const completedLessons = new Set(
    (progress.lessons || [])
      .filter((entry) => entry.completedAt && lessonIds.has(String(entry.lesson && (entry.lesson._id || entry.lesson))))
      .map((entry) => String(entry.lesson && (entry.lesson._id || entry.lesson))),
  )
  const total = lessonIds.size + getEvaluationTypes(module).length
  return total ? Math.floor(((completedLessons.size + getCompletedEvaluationTypes(module, progress).length) / total) * 100) : 0
}
